import { env } from '@/env';
import type { ACCESSEligibilityResultCode } from '@/types/registration';

const INVITE_ALLOWED_MODES = new Set(['development', 'staging', 'e2e', 'automation']);

export const INVITE_PARAM = 'invite';

export const INVITE_STANDIN_MBI = '1EG4TE5MK73';

export const INVITE_ELIG_CODE: ACCESSEligibilityResultCode = 'eligible';

export const isWregInviteEnabled = (): boolean =>
  env.INVITE_BYPASS_ENABLED === 'true' && INVITE_ALLOWED_MODES.has(env.MODE);

export const isWregInviteActive = (search: URLSearchParams): boolean =>
  isWregInviteEnabled() && search.get(INVITE_PARAM) === 'true';
